import { render } from "./LayoutCard.vue?vue&type=template&id=207dcc42&scoped=true&ts=true"
import script from "./LayoutCard.vue?vue&type=script&lang=ts"
export * from "./LayoutCard.vue?vue&type=script&lang=ts"

import "./LayoutCard.vue?vue&type=style&index=0&id=207dcc42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207dcc42"]])

export default __exports__